import { Box, Button, Skeleton } from "@mui/material";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useReducer, useState, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { FileReceiptGridReducerAction } from "../Store/FileReceiptGridReducer";
import BasicReceiptInfo from "./BasicReceiptInfo";
import CashReceiptDetails from "./CashReceiptDetails";
import ChequeReceiptDetails from "./ChequeReceiptDetails";
import NeftReceiptDetails from "./NeftReceiptDetails";
import StlapFooter from "../CustomComponents/StlapFooter";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

var fileReceiptInitialState = {
  branch: null,
  branchCode: "",
  applicationNum: "",
  receiptType: "",
  voucherDate: new Date(dayjs(new Date()).format("MM/DD/YYYY")),
  receiptFor: "",
  reference: "",
  customerName: "",
  receiptAmt: "",
  totalReceiptAmt: "",
  depositBank: "",
  depositBankCode: "",
  depositBankBranchKey: "",
  utrNo: "",
  narration: "",
  cashHandleCharge: "",
  depositAmount: "",
  cashMode: "",
  bankAccountNum: "",
  accHolderName: "",
  reasonForReceipt: "",
  chequeType: "",
  chequeMode: "",
  chequeNum: "",
  chequeDate: null,
  bankReqDate: "",
  drawerBank: "",
  drawerBranch: "",
  trnNo: "",
  disbStatus: "",
  fileNum: "",
  glAccCode: "",
  glAcc: "",
  creditAmt: "",
  thirdPartyName: "",
  sourceOfFund: "",
  customerId: "",
  voucherNum: "",
  bankingDate: null,
  realizationDate: null,
};
const FileReceipt = (props) => {
  //using dispatch
  const dispatchRedux = useDispatch();
  const [showNeft, setshowNeft] = useState(false);
  const [showCash, setshowCash] = useState(false);
  const [showCheque, setshowCheque] = useState(false);
  const [showCredit, setshowCredit] = useState(false);
  const [branchValue, setBranchValue] = useState("");
  const [branchCodeValue, setBranchCodeValue] = useState("");
  const [applicationNum, setApplicationNum] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [disbStatus, setDisbStatus] = useState("");

  const [tabValue, settabValue] = useState("1");
  const [glAccountDataMap, setGlAccountDataMap] = useState({});
  const dateEnableDetails = useSelector(
    (state) => state.fileReceiptGrid.dateEnableDetails
  );
  const chequeDateEnable = dateEnableDetails.chequeDateEnable;
  const bankDateEnable = dateEnableDetails.bankDateEnable;
  const voucherDateEnable = dateEnableDetails.voucherDateEnable;
  const bankingDateEnable = dateEnableDetails.bankingDateEnable;
  const realizationDateEnable = dateEnableDetails.realizationDateEnable;
  // based on customer id's.
  const [appNumByCustIdBranch, setAppNumByCustIdBranch] = useState([]);
  // branches with code
  const [branchNamesWithCodes, setBranchNamesWithCodes] = useState([]);

  const userName = useSelector((state) => state.branch.userName);

  const [goClick, setGoClick] = useState(false);

  const [cashHandlingGlAccCode, setCashHandlingGlAccCode] = useState("");

  const handleTabChange = (newValue) => {
    settabValue(newValue);
    setshowCredit(false);
  };

  const fileReceiptScreenFields = {
    branch: "branch",
    branchCode: "branchCode",
    applicationNum: "applicationNum",
    receiptType: "receiptType",
    voucherDate: "voucherDate",
    receiptFor: "receiptFor",
    reference: "reference",
    customerName: "customerName",
    receiptAmt: "receiptAmt",
    totalReceiptAmt: "totalReceiptAmt",
    depositBank: "depositBank",
    depositBankCode: "depositBankCode",
    depositBankBranchKey: "depositBankBranchKey",
    utrNo: "utrNo",
    narration: "narration",
    cashHandleCharge: "cashHandleCharge",
    depositAmount: "depositAmount",
    cashMode: "cashMode",
    bankAccountNum: "bankAccountNum",
    accHolderName: "accHolderName",
    reasonForReceipt: "reasonForReceipt",
    chequeType: "chequeType",
    chequeMode: "chequeMode",
    chequeNum: "chequeNum",
    chequeDate: "chequeDate",
    bankReqDate: "bankReqDate",
    drawerBank: "drawerBank",
    drawerBranch: "drawerBranch",
    trnNo: "trnNo",
    disbStatus: "disbStatus",
    fileNum: "fileNum",
    glAccCode: "glAccCode",
    glAcc: "glAcc",
    creditAmt: "creditAmt",
    voucherNum: "voucherNum",
    thirdPartyName: "thirdPartyName",
    sourceOfFund: "sourceOfFund",
    customerId: "customerId",
    bankingDate: "bankingDate",
    realizationDate: "realizationDate",
  };

  const reducer = (state, action) => {
    let initialstateValue = { ...fileReceiptInitialState };
    let currentstateValue = { ...state };
    switch (action.type) {
      case fileReceiptScreenFields.accHolderName:
        return { ...state, accHolderName: action.value };
      case fileReceiptScreenFields.bankAccountNum:
        return { ...state, bankAccountNum: action.value };
      case fileReceiptScreenFields.bankReqDate:
        return { ...state, bankReqDate: action.value };
      case fileReceiptScreenFields.bankingDate:
        return { ...state, bankingDate: action.value };
      case fileReceiptScreenFields.realizationDate:
        return { ...state, realizationDate: action.value };
      case fileReceiptScreenFields.branch:
        setBranchValue(action.value ? action.value : "");
        initialstateValue.branch = branchValue;
        const branchData = branchNamesWithCodes.find((branch) => {
          return branch.label === action.value ? action.value : "";
        });
        setBranchCodeValue(action.value ? branchData.code : null);
        initialstateValue.branchCode = action.value ? branchData.code : null;
        dispatchRedux(FileReceiptGridReducerAction.updateReceiptType(""));
        return { ...initialstateValue, branch: action.value };
      case fileReceiptScreenFields.applicationNum:
        setApplicationNum(action.value);
        initialstateValue.branch = branchValue;
        initialstateValue.applicationNum = action.value;
        initialstateValue.receiptFor = currentstateValue.receiptFor;
        initialstateValue.customerId = currentstateValue.customerId;
        initialstateValue.branchCode = branchCodeValue;
        dispatchRedux(FileReceiptGridReducerAction.updateReceiptType(""));
        return { ...initialstateValue, applicationNum: action.value };
      case fileReceiptScreenFields.cashHandleCharge:
        return { ...state, cashHandleCharge: action.value };
      case fileReceiptScreenFields.cashMode:
        return { ...state, cashMode: action.value };
      case fileReceiptScreenFields.chequeDate:
        return { ...state, chequeDate: action.value };
      case fileReceiptScreenFields.chequeMode:
        return { ...state, chequeMode: action.value };
      case fileReceiptScreenFields.chequeNum:
        return { ...state, chequeNum: action.value };
      case fileReceiptScreenFields.chequeType:
        return { ...state, chequeType: action.value };
      case fileReceiptScreenFields.creditAmt:
        return { ...state, creditAmt: action.value };
      case fileReceiptScreenFields.customerName:
        setCustomerName(action.value);
        return { ...state, customerName: action.value };
      case fileReceiptScreenFields.depositAmount:
        return { ...state, depositAmount: action.value };
      case fileReceiptScreenFields.depositBank:
        return { ...state, depositBank: action.value };
      case fileReceiptScreenFields.depositBankCode:
        return { ...state, depositBankCode: action.value };
      case fileReceiptScreenFields.depositBankBranchKey:
        return { ...state, depositBankBranchKey: action.value };
      case fileReceiptScreenFields.disbStatus:
        setDisbStatus(action.value);
        return { ...state, disbStatus: action.value };
      case fileReceiptScreenFields.drawerBank:
        return { ...state, drawerBank: action.value };
      case fileReceiptScreenFields.drawerBranch:
        return { ...state, drawerBranch: action.value };
      case fileReceiptScreenFields.fileNum:
        return { ...state, fileNum: action.value };
      case fileReceiptScreenFields.glAcc:
        return { ...state, glAcc: action.value };
      case fileReceiptScreenFields.glAccCode:
        return { ...state, glAccCode: action.value };
      case fileReceiptScreenFields.narration:
        return { ...state, narration: action.value };
      case fileReceiptScreenFields.reasonForReceipt:
        return { ...state, reasonForReceipt: action.value };
      case fileReceiptScreenFields.receiptAmt:
        if (currentstateValue.receiptType === "CASH") {
          currentstateValue.cashHandleCharge = 0;
        } else {
          currentstateValue.totalReceiptAmt = action.value;
        }
        return { ...currentstateValue, receiptAmt: action.value };
      case fileReceiptScreenFields.receiptFor:
        initialstateValue.branch = branchValue;
        initialstateValue.receiptFor = currentstateValue.receiptFor;
        initialstateValue.branchCode = branchCodeValue;
        dispatchRedux(FileReceiptGridReducerAction.updateReceiptType(""));
        return { ...initialstateValue, receiptFor: action.value };
      case fileReceiptScreenFields.sourceOfFund:
        initialstateValue.branch = branchValue;
        initialstateValue.applicationNum = applicationNum;
        initialstateValue.customerName = customerName;
        initialstateValue.disbStatus = disbStatus;
        initialstateValue.receiptFor = currentstateValue.receiptFor;
        initialstateValue.thirdPartyName = "";
        initialstateValue.customerId = currentstateValue.customerId;
        initialstateValue.branchCode = branchCodeValue;
        return { ...state, sourceOfFund: action.value };
      case fileReceiptScreenFields.receiptType:
        // set to intial state first and then set the dispatched value.
        initialstateValue.branch = branchValue;
        initialstateValue.applicationNum = applicationNum;
        initialstateValue.customerName = customerName;
        initialstateValue.disbStatus = disbStatus;
        initialstateValue.receiptFor = currentstateValue.receiptFor;
        initialstateValue.sourceOfFund = currentstateValue.sourceOfFund;
        initialstateValue.thirdPartyName = currentstateValue.thirdPartyName;
        initialstateValue.customerId = currentstateValue.customerId;
        initialstateValue.branchCode = branchCodeValue;
        initialstateValue.voucherDate = currentstateValue.voucherDate;
        if (action.value === "CASH") {
          initialstateValue.cashMode = "CASH";
        }
        return { ...initialstateValue, receiptType: action.value };
      case fileReceiptScreenFields.customerId:
        initialstateValue.branch = branchValue;
        initialstateValue.receiptFor = currentstateValue.receiptFor;
        initialstateValue.branchCode = branchCodeValue;
        dispatchRedux(FileReceiptGridReducerAction.updateReceiptType(""));
        return { ...initialstateValue, customerId: action.value };
      case fileReceiptScreenFields.reference:
        return { ...state, reference: action.value };
      case fileReceiptScreenFields.totalReceiptAmt:
        return { ...state, totalReceiptAmt: action.value };
      case fileReceiptScreenFields.trnNo:
        return { ...state, trnNo: action.value };
      case fileReceiptScreenFields.utrNo:
        return { ...state, utrNo: action.value };

      case fileReceiptScreenFields.thirdPartyName:
        return { ...state, thirdPartyName: action.value };

      case fileReceiptScreenFields.voucherDate:
        currentstateValue.chequeDate = action.value;
        return { ...currentstateValue, voucherDate: action.value };
      case fileReceiptScreenFields.voucherNum:
        // voucher exist for view & modify.
        initialstateValue.branch = branchValue;
        initialstateValue.applicationNum = applicationNum;
        initialstateValue.branchCode = branchCodeValue;
        dispatchRedux(FileReceiptGridReducerAction.updateReceiptType(""));
        return { ...initialstateValue, voucherNum: action.value };
      case "viewOrModifyModeLoad":
        if (action.value.sourceOfFund === "Third Party") {
          dispatchRedux(
            FileReceiptGridReducerAction.updateThirdPartDisplayFlag(true)
          );
          dispatchRedux(
            FileReceiptGridReducerAction.updateThirdPartyNameDisableModeFlag(
              true
            )
          );
        } else {
          dispatchRedux(
            FileReceiptGridReducerAction.updateThirdPartDisplayFlag(false)
          );
        }
        return { ...action.value };
      default:
        // this method also call on clear btn operation in view & modify mode.
        // so reset the UI to show only filter.
        setshowNeft(false);
        setshowCash(false);
        setshowCheque(false);
        setshowCredit(false);
        dispatchRedux(
          FileReceiptGridReducerAction.updatePrePayReceiptMode(false)
        );
        dispatchRedux(FileReceiptGridReducerAction.resetPrepayDetails());
        dispatchRedux(
          FileReceiptGridReducerAction.updateCurrentReceiptCustomerData({})
        );
        // reset the seperate saved state variables also.
        setBranchValue("");
        setBranchCodeValue("");
        setApplicationNum("");
        setCustomerName("");
        setDisbStatus("");
        return { ...fileReceiptInitialState };
    }
  };

  const [fileReceiptState, dispatch] = useReducer(
    reducer,
    fileReceiptInitialState
  );

  const loadTabsData = () => {
    // on each render set the tab value to 1.
    settabValue("1");
    if (
      fileReceiptState.receiptType === "Fund Transfer" ||
      fileReceiptState.receiptType === "UPI"
    ) {
      setshowNeft(true);
      setshowCash(false);
      setshowCheque(false);
      setshowCredit(false);
    } else if (fileReceiptState.receiptType === "CASH") {
      setshowNeft(false);
      setshowCash(true);
      setshowCheque(false);
      setshowCredit(false);
    } else if (fileReceiptState.receiptType === "CHEQUE") {
      setshowNeft(false);
      setshowCash(false);
      setshowCheque(true);
      setshowCredit(false);
    } else {
      setshowNeft(false);
      setshowCash(false);
      setshowCheque(false);
      setshowCredit(false);
    }
  };

  useEffect(() => {
    dispatchRedux(
      FileReceiptGridReducerAction.updateFileReceiptInitialState(
        fileReceiptInitialState
      )
    );
    const branchWithCodes = GetBranchDetailsWithCode();
    setBranchNamesWithCodes(branchWithCodes);

    const loadTabsForCreateMode = async () => {
      loadTabsData();
    };

    // load branches in case of customerid .
    const getBranchesByCustomerId = async () => {
      try {
        const response = await axios.post(
          "/losCustomer/getBranchByCustomerId",
          {
            customerId: fileReceiptState.customerId,
          }
        );
        const data = [...response.data];
        let mapRecords = [];
        data.forEach((record) => {
          mapRecords.push(record);
        });
        setAppNumByCustIdBranch(mapRecords);
      } catch (error) {
        console.log(error);
      }
    };
    loadTabsForCreateMode();

    if (
      fileReceiptState.receiptFor === "Customer ID" &&
      fileReceiptState.customerId !== ""
    ) {
      getBranchesByCustomerId();
    }

    const getCustomerBankDetailsByAppNum = async () => {
      const applicationNumValue =
        typeof fileReceiptState.applicationNum === "string"
          ? fileReceiptState.applicationNum
          : fileReceiptState.applicationNum[0];
      const response = await axios.post(
        "/losCustomer/getCustBankDetailsByAppNum",
        {
          applicationNum: applicationNumValue,
        }
      );

      if (response.data.length > 0) {
        const record = response.data[0];
        dispatch({
          type: fileReceiptScreenFields.bankAccountNum,
          value: record.bankAccountNum,
        });
        dispatch({
          type: fileReceiptScreenFields.accHolderName,
          value: record.accHoldrName,
        });
      }
    };

    if (
      fileReceiptState.receiptType === "CHEQUE" &&
      fileReceiptState.receiptFor !== "Customer ID"
    ) {
      getCustomerBankDetailsByAppNum();
    }
  }, [fileReceiptState.receiptType, fileReceiptState.receiptFor, props.mode]);

  useEffect(() => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const getCashHandlingGlCode = async () => {
      const response = await axios.post(
        "/filereceipt/getCashHanglingGlAcc",
        {}
      );
      const cashHandlingGlAccCode = response.data;
      setCashHandlingGlAccCode(cashHandlingGlAccCode);
    };
    const getGLData = async () => {
      const codes = branchWithCodes.map((branch) => branch.code);
      const gLResponseData = await axios.post(
        "/filereceipt/getGLAccountDataByBranch",
        {
          shflApisModel: {
            apiCode: "FILE_GL_ACC_LOV_API",
            createdBy: userName,
            lastModifiedBy: userName,
          },
          branchCodes:
            fileReceiptState.receiptFor === "Customer ID"
              ? []
              : [fileReceiptState.branchCode],
          customerId:
            fileReceiptState.receiptFor === "Customer ID"
              ? fileReceiptState.customerId
              : null,
        }
      );
      let mapData = {};
      if (Object.keys(gLResponseData.data).length > 0) {
        const responseData = { ...gLResponseData.data };
        codes.forEach((code) => {
          let value = responseData[code];
          if (Number(value?.status) === 1) {
            mapData[code] = value.ledger_details;
          } else {
            mapData[code] = [];
          }
        });
      }
      setGlAccountDataMap(mapData);
    };
    if (
      (fileReceiptState.receiptType && fileReceiptState.receiptType !== "") ||
      (props.mode && props.mode !== "" && props.mode !== "CREATE")
    ) {
      getGLData();
      getCashHandlingGlCode();
    }
  }, [fileReceiptState.receiptType, props.mode]);

  useEffect(() => {
    // simply re-render the dom when glaccount data receives.
    console.log(glAccountDataMap);
  }, [glAccountDataMap]);

  useEffect(() => {
    // when receipt reload we need to reset the prepay content on store.
    dispatchRedux(FileReceiptGridReducerAction.updatePrePayReceiptMode(false));
    dispatchRedux(FileReceiptGridReducerAction.resetPrepayDetails());
  }, []);

  const validateFieldsHandler = (event) => {
    loadTabsData();
  };

  const onGoClick = (flag) => {
    setGoClick(flag);
  };

  useEffect(() => {
    window.addEventListener("keydown", onKeyPressEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyPressEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [
    voucherDateEnable,
    bankDateEnable,
    chequeDateEnable,
    bankingDateEnable,
    realizationDateEnable,
  ]);
  const onKeyUnmountEventHandler = (event) => {
    dispatch(
      CommonShortCutAction.removeDefaultShortCutValue({
        event: event,
        screen: "fileReceipt",
      })
    );
  };
  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();
    let date = new Date();
    if (event.ctrlKey) {
      switch (charCode) {
        case "o":
          date.setDate(date.getDate() + 1);
          voucherDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.voucherDate,
              value: date,
            });
          bankDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.bankReqDate,
              value: date,
            });
          chequeDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.chequeDate,
              value: date,
            });
          bankingDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.bankingDate,
              value: date,
            });
          realizationDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.realizationDate,
              value: date,
            });
          break;
        case "i":
          voucherDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.voucherDate,
              value: date,
            });
          chequeDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.chequeDate,
              value: date,
            });
          bankDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.bankReqDate,
              value: date,
            });
          bankingDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.bankingDate,
              value: date,
            });
          realizationDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.realizationDate,
              value: date,
            });
          break;
        case "p":
          date.setDate(date.getDate() - 1);
          chequeDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.chequeDate,
              value: date,
            });
          bankingDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.bankingDate,
              value: date,
            });
          realizationDateEnable &&
            dispatch({
              type: fileReceiptScreenFields.realizationDate,
              value: date,
            });
          break;
        default:
          break;
      }
    }
  };

  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <BasicReceiptInfo
          fileReceiptState={fileReceiptState}
          dispatch={dispatch}
          fileReceiptScreenFields={fileReceiptScreenFields}
          screenMode={props.mode}
          screenTitle={props.screenTitle}
          loadTabsData={loadTabsData}
          validateFieldsHandler={validateFieldsHandler}
          goClickEvent={onGoClick}
        />

        {goClick && Object.keys(glAccountDataMap).length === 0 ? (
          <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
            <Skeleton
              variant="rounded"
              animation="wave"
              width="100%"
              height={
                window.innerHeight > 650 ? window.innerHeight / 1.8 : "260px"
              }
            />
          </Box>
        ) : (
          <>
            {goClick && showNeft && (
              <NeftReceiptDetails
                tabValue={tabValue}
                settabValue={settabValue}
                handleTabChange={handleTabChange}
                fileReceiptState={fileReceiptState}
                dispatch={dispatch}
                fileReceiptScreenFields={fileReceiptScreenFields}
                screenMode={props.mode}
                glAccountDataMap={glAccountDataMap}
                appNumByCustIdBranch={appNumByCustIdBranch}
                branchNamesWithCodes={branchNamesWithCodes}
                cashHandlingGlAccCode={cashHandlingGlAccCode}
              />
            )}

            {goClick && showCash && (
              <CashReceiptDetails
                tabValue={tabValue}
                settabValue={settabValue}
                handleTabChange={handleTabChange}
                fileReceiptState={fileReceiptState}
                dispatch={dispatch}
                fileReceiptScreenFields={fileReceiptScreenFields}
                screenMode={props.mode}
                glAccountDataMap={glAccountDataMap}
                appNumByCustIdBranch={appNumByCustIdBranch}
                branchNamesWithCodes={branchNamesWithCodes}
                cashHandlingGlAccCode={cashHandlingGlAccCode}
              />
            )}

            {goClick && showCheque && (
              <ChequeReceiptDetails
                tabValue={tabValue}
                settabValue={settabValue}
                handleTabChange={handleTabChange}
                fileReceiptState={fileReceiptState}
                dispatch={dispatch}
                fileReceiptScreenFields={fileReceiptScreenFields}
                screenMode={props.mode}
                glAccountDataMap={glAccountDataMap}
                appNumByCustIdBranch={appNumByCustIdBranch}
                branchNamesWithCodes={branchNamesWithCodes}
                cashHandlingGlAccCode={cashHandlingGlAccCode}
              />
            )}
          </>
        )}
      </Box>
      <StlapFooter />
    </>
  );
};

export default FileReceipt;
